import { Injectable } from '@angular/core';
import { OktaAuthService } from '@okta/okta-angular';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Dictionary } from '@core/models/dictionary';
import { map, retry } from 'rxjs/operators';
import { environment } from '@env/environment';

@Injectable({
	providedIn: 'root'
})
export class RestService {
	public apiUrl: string;
	public headers: HttpHeaders;
	public options: any;
	public filters: any;
	private token: string;

	constructor(private oktaAuthService: OktaAuthService, private httpClient: HttpClient) {

		if (environment.name == 'mock') {
			this.apiUrl = 'http://localhost:3000/';
		} else {
			this.apiUrl = 'http://localhost:59512/';
		}
	}

	public async post<T>(url: string, formData: FormData, headers: Dictionary[] = [], out: T) {
		return await this.setHeaders(headers).then(
			options => {
				return this.httpClient.post(this.apiUrl + url, formData, options)
					.pipe(map(
						(res) => {
							return Object.assign(out, res);
						}
					));
			}
		);
	}

	public async put<T>(url: string, formData: FormData, headers: Dictionary[] = [], out: T) {
		return await this.setHeaders(headers).then(
			options => {
				return this.httpClient.put(this.apiUrl + url, formData, options)
					.pipe(map(
						(res) => {
							return Object.assign(out, res);
						}
					));
			}
		);
	}

	public async get<T>(url: string, headers: Dictionary[] = [], out: T, sendResidenceHeader: boolean = true) {

		return await this.setHeaders(headers, sendResidenceHeader).then(
			options => {
				return this.httpClient.get(this.apiUrl + url, options)
					.pipe(map(
						(res) => {
							return Object.assign(out, res);
						}
					), retry(3));
			}
		);
	}

	public async getFile(url: string, headers: Dictionary[] = [], responseType = 'arraybuffer') {
		url = this.apiUrl + url;
		return this.getFileByAbsoluteUrl(url, headers, responseType);
	}

	public async getFileByAbsoluteUrl(url: string, headers: Dictionary[] = [], responseType = 'arraybuffer') {
		return await this.setHeaders(headers, true, responseType).then(
			options => {
				// this.options.responseType = responseType;
				return this.httpClient.get(url, options)
					.pipe(map(
						(res) => {
							return res;
						}
					));
			}
		);
	}

	public async delete<T>(url: string, headers: Dictionary[] = [], formData: FormData = null, out: T) {
		return await this.setHeaders(headers).then(
			options => {
				options.body = formData;
				return this.httpClient.delete(this.apiUrl + url, options)
					.pipe(map(
						(res) => {
							return Object.assign(out, res);
						}
					));
			}
		);
	}

	private async setHeaders(headers: Dictionary[] = [], sendResidenceHeader: boolean = true, respType = 'json') {
		return await this.oktaAuthService.getAccessToken().then(
			token => {
				this.token = token;
				this.headers = new HttpHeaders(
					{
						Authorization: 'Bearer ' + this.token
					}
				);

				if (sendResidenceHeader) {
					const config = JSON.parse(localStorage.getItem('config'));
					if (config && config.residence) {
						this.headers = this.headers.append('Residence', config.residence.code);
					}
				}

				for (const header of headers) {
					if (header) {
						this.headers = this.headers.append(header.key, header.value);
					}
				}

				this.options = {
					headers: this.headers,
					responseType: respType
				};

				return this.options;
			}
		);
	}

	public getToken() {
		return this.token;
	}

	public getOptions() {
		return this.options;
	}
}
